import React from 'react';
import Hero from './components/exam-related-info/Hero';
import Main from './components/exam-related-info/Main';

const ExamRelatedInfo = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default ExamRelatedInfo;